"use client";

import { ChatLoader } from "~/chat/components/chat-loader";
import { useWorkspace } from "~/workspaces/hooks/use-workspace";
import { useGetWorkspacePages } from "~/workspaces/queries/get-workspace-pages-query";
import { getInitialWorkspacePage } from "~/workspaces/utils/get-initial-workspace-page";
import { useWorkspaceRedirect } from "~/common/hooks/dom/useWorkspaceRedirect";

function WorkspacePage() {
  const { selectedWorkspace } = useWorkspace();

  const initialPage = useGetWorkspacePages(
    { workspaceId: selectedWorkspace.id },
    (pages) => getInitialWorkspacePage(pages),
  );

  useWorkspaceRedirect(selectedWorkspace.slug, initialPage.data);

  return (
    <div className="flex flex-col items-center justify-center h-full w-full">
      <ChatLoader variant="ghost" />
    </div>
  );
}

export default WorkspacePage;
